import buildMetricValuesHook from '../utils/buildMetricValuesHook'

export const dhWbListLocationGroupLossPreventionKpisConfigs = {
  discountCompsTotal: 'price',
  discountCheckCountTotal: 'number',
  lossPreventionCompsDeletes: 'price',
  lossPreventionCompsOverrings: 'price',
  lossPreventionCompsRefunds: 'price',
  lossPreventionCompsVoids: 'price',
  r365TLossPreventionCompsCashOverShort: 'price',
} as const

const useDhWbListLocationGroupLossPreventionKpis = buildMetricValuesHook({
  groupFilterType: 'corporate',
  metrics: {
    codes: ['discount_comps_total', 'discount_check_count_total'],
    groups: ['Expo Module - Loss Prevention Comps'],
  },
})

export default useDhWbListLocationGroupLossPreventionKpis
